import Icon from 'veui/components/Icon'
import { IconPowerOff } from 'dls-icons-vue'

Icon.register('power-off', IconPowerOff)
